export const MediaDataHomens = [
  { img: "/Images/Men/1.jpeg" },
  { img: "/Images/Men/2.jpeg" },
  { img: "/Images/Men/3.jpeg" },
  { img: "/Images/Men/4.jpeg" },
  { img: "/Images/Men/5.jpeg" },
  { img: "/Images/Men/6.jpeg" },
  { img: "/Images/Men/7.jpeg" },
];
